import React, { useState } from 'react';
import './css/ContactBanner.css';
import ApplicationPopup from '../Popup/ApplicationPopup';

const ContactBanner = () => {
  const [isPopupOpen, setIsPopupOpen] = useState(false);

  const openPopup = () => {
    setIsPopupOpen(true);
  };

  const closePopup = () => {
    setIsPopupOpen(false);
  };

  return (
    <>
      <section className="contact-banner" id="contact-banner">
        <div className="container contact-banner-container">
          <div className="contact-banner-content">
            <div className="banner-text">
              <h2 className="banner-title-contact">
                Остались вопросы?
              </h2>
              <p className="banner-description-contact">
                Мы предоставляем <strong> пилот на 3 станции</strong>, чтобы вы могли 
                протестировать нашу систему и убедиться в её эффективности
              </p>
            </div>
            
            <div className="banner-actions">
              <button className="cta-button secondary" onClick={openPopup}>
                <span>Связаться с менеджером</span>
                <i className="far fa-comment-dots"></i>
              </button>
            </div>
          </div>
          
          <div className="banner-visual">
            <div className="visual-element demo-access">
              <div className="demo-icon">
                <i className="fas fa-rocket"></i>
              </div>
              <span>Демо-доступ</span>
            </div>
            <div className="visual-element support">
              <div className="support-icon">
                <i className="fas fa-headset"></i>
              </div>
              <span>Поддержка 24/7</span>
            </div>
          </div>
        </div>
      </section>

      {/* Попап оставления заявки */}
      <ApplicationPopup type="Связаться с менеджером" title = "Связаться с менеджером" isOpen={isPopupOpen} onClose={closePopup} />
    </>
  );
};

export default ContactBanner;